import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import ClickEvent = JQuery.ClickEvent;

export interface DropdownProps {

    /**
     * Selektor dla dropdown'a
     * Można użyć '>', aby wybrać następny element z klasą .dropdown
     */
    dropdown: string;

    /**
     * Ukrycie dropa po kliknięciu w drop
     */
    hideOnClickDropdown: boolean;

    /**
     * Przesunięcie w poziomie
     */
    horizontalOffset?: number;

    /**
     * Pozycja w poziomie
     */
    horizontalPos: "left" | "middle" | "right";


    /**
     * Przesunięcie w poziomie
     */
    verticalOffset?: number;

    /**
     * Pozycja w poziomie
     */
    verticalPos: "top" | "middle" | "bottom";

}

@Dce("Dropdown")
export default class Dropdown extends DceComponent<DropdownProps> {

    protected dropButton: JQuery<HTMLElement>;

    protected dropdown: JQuery<HTMLElement>;

    protected scrollListener: EventListener = (event) => this.onScroll(event);

    protected documentMouseUpListener: EventListener = (event:MouseEvent) => this.documentMouseUp(event);

    protected hidding: boolean = false;

    constructor(elem: DceHTMLElement, props: DropdownProps) {
        super(elem, props);

        this.dropButton = $(this.elem);

        this.setupDropdown();

        this.dropButton.on('click', e => {
            this.dropButtonClick(e);
        });

    }

    private dropButtonClick(e: ClickEvent){
        e.preventDefault();

        if(this.hidding){
            this.hidding = false;
            return;
        }

        if(this.dropButton.hasClass('disabled') || this.dropButton.is(":disabled") ){
            return;
        }

        this.toggle();
    }


    protected toggle(){

        if(this.dropdown.is(":visible")){
            this.hideDropdown();
        }else{

            //this.dropdown.children('a').show();
            this.showDropdown();
            this.updateDropdownPosition();

        }

    };

    private findFixedOffsetParent(elem: HTMLElement): HTMLElement{

        if(null == elem.parentElement || elem.parentElement.tagName.toLowerCase() == 'body'){
            return null;
        }

        let styles = getComputedStyle(elem.parentElement);

        if(styles.transform != null && styles.transform !== 'none'){
            return elem.parentElement;
        }

        return this.findFixedOffsetParent(elem.parentElement);
    }

    private updateDropdownPosition(){

        let rect = this.dropButton[0].getBoundingClientRect();

        let fixedParent = this.findFixedOffsetParent(this.dropButton[0]);

        if(fixedParent != null){
            let parentRect = fixedParent.getBoundingClientRect();

            let l = rect.left - parentRect.left;
            let t = rect.top - parentRect.top;

            rect = new DOMRect(
                l, t, rect.width, rect.height
            );
        }


        let buttonWidth = rect.width;
        let dropdownWidth = this.dropdown.outerWidth();

        let left = rect.left;

        switch (this._props.horizontalPos){
            case "right":
                left = rect.left - dropdownWidth + buttonWidth;
                break;
            case "middle":
                left = Math.round(rect.left - (dropdownWidth/2) + (buttonWidth/2));
                break;
            default:

        }

        if(this.props.horizontalOffset){
            left += this.props.horizontalOffset;
        }

        if(left < 0){
            left = 0;
        }

        let buttonHeight = rect.height;
        let dropdownHeight = this.dropdown.outerHeight();

        let top = rect.top + rect.height;

        let currentPos = this._props.verticalPos;

        if(this._props.verticalPos == 'bottom' && (top + dropdownHeight) > window.innerHeight){
            currentPos = 'top';
        }

        if(this._props.verticalPos == 'top' && (rect.top - dropdownHeight) < 0){
            currentPos = 'bottom';
        }

        switch (currentPos){
            case "bottom":
                top = rect.top + rect.height;
                break;
            case "top":
                top = rect.top - dropdownHeight;
                break;
            case "middle":
                top = Math.round(rect.top - (dropdownHeight/2) + (buttonHeight/2));
                break;
            default:
        }

        if(this.props.verticalOffset){
            top += this.props.verticalOffset;
        }

        if(left < 0){
            left = 0;
        }

        this.dropdown.css({
            'top': top + "px",
            'left': left + 'px'
        });

    }

    private documentMouseUp(e:MouseEvent){

        if(this.dropdown.is(":visible")){
            let target: HTMLElement = e.target as HTMLElement;

            if(!this._props.hideOnClickDropdown){

                if(target == this.dropdown[0] || $.contains(this.dropdown[0], target)){
                    if(!target.getAttribute('dropdown-close')){
                        return;
                    }
                }
            }

            if(target == this.dropButton[0] || $.contains(this.dropButton[0], target)){
                this.hidding = true;
            }

            this.hideDropdown();
        }

    }

    private hideDropdown(){
        this.dropdown.hide();
        this.dropButton.removeClass('dropdown-open');

        window.removeEventListener('scroll', this.scrollListener, true);
        document.removeEventListener('mouseup', this.documentMouseUpListener, true);
    }

    private showDropdown(){
        this.dropdown.show();
        this.dropButton.addClass('dropdown-open');

        document.addEventListener('mouseup', this.documentMouseUpListener);
        window.addEventListener('scroll', this.scrollListener, true);

        this.dropdown.find('[data-drop-focus]').trigger('focus');
    }

    private onScroll(event:Event){
        this.updateDropdownPosition();
    }

    protected setupDropdown() {

        if (this._props.dropdown == '>') {
            this.dropdown = this.dropButton.next('.dropdown');
        } else {
            this.dropdown = $(this._props.dropdown);
        }

        this.dropdown.css({
            'position': 'fixed'
        });

        if(this.dropButton.outerWidth() > this.dropdown.outerWidth()){
            this.dropdown.css({
                'min-width': this.dropButton.outerWidth() + 'px'
            });
        }

    }

    onRemove() {
        // if(this.dropdown) {
        //     this.dropdown.remove();
        // }
    }

    defaultProps(): Partial<DropdownProps> {
        return {
            dropdown: '>',
            hideOnClickDropdown: true,
            horizontalOffset: 0,
            horizontalPos: 'left',
            verticalOffset: 0,
            verticalPos: 'bottom',
        }
    }
}
